module.exports = __webpack_public_path__ + "media/assets/DangerAlert-a3f02a03dbf200e4ea9040e1f2b2c9b0.svg";